export default (feature: string, permissions: string[]): boolean =>
  permissions.includes(feature);
